module.exports = __webpack_public_path__ + "img/公共池.a61d8542.png";